import React from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
// import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import _ from 'lodash'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import PropTypes from 'prop-types';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { format, parse, isValid } from 'date-fns'

const useStyles = makeStyles(theme => ({
    textInput: {        
        padding: theme.spacing(1)
    },
    textareaInput: {        
        padding: theme.spacing(1)
    },
    textarea: {
        width:"100%",
        height:"150px",
        resize: "none",
        padding: theme.spacing(1),
        fontSize: theme.typography.fontSize,
        borderColor: theme.palette.color,
        whiteSpace:"pre-wrap"
    },
    formControl:{
        width: "100%"
    },
    selectInput:{
        padding: theme.spacing(1),
        width: "100%"
    },
    selectItem:{
        wordBreak: "break-all",
        whiteSpace: "unset",
    },
    checkboxInput:{
        padding: theme.spacing(0,1),
        // width: "100%"
    },
    checkBoxGroupInput:{
        padding: theme.spacing(1),
        display:"flex",
        width:"100%",
        // justifyContent:"space-between",
        flexWrap:"wrap",
        alignItems:"center",
        
    },
    radioGroup:{
        padding: theme.spacing(1),
        // display: "flex",        
        // flexDirection:"row"
    }
}))

const TextInput = React.memo((props) =>{

    const classes = useStyles()

    const handleChange = (e) => {         
        props.setValue(props.field, e.target.value)
    }

    // console.log(props.field+":render");    

    return <div className={classes.textInput}>
        <TextField
            id={props.field}
            label={props.label}
            type={props.type?props.type:"text"}
            value={props.value===null?"":props.value}
            onChange={handleChange}
            fullWidth
            variant={props.variant?props.variant:"standard"}
            disabled={props.disabled?props.disabled:false}    
            // margin="dense"        
        />
    </div>    
})

const AutoCompleteInput = React.memo((props) =>{
    const classes = useStyles()

    // console.log(props.field+":render");     
    const [initialValue, setInitialValue] = React.useState(props.value?props.value:"")   

    const handleChange = (event, newInputValue) => {      
        props.setValue(props.field, newInputValue)
    }    


    return <div className={classes.textInput}>
        <Autocomplete            
            id={props.field}
            options={JSON.parse(props.options)}
            freeSolo                               
            disableClearable        
            defaultValue={initialValue}
            onInputChange={handleChange} 
            inputValue={props.value?props.value:""}                                          
            fullWidth                             
            disabled={props.disabled?props.disabled:false}                               
            renderInput={(params) => <TextField
                {...params} 
                // margin="dense"   
                label={props.label}                   
                variant={props.variant?props.variant:"outlined"}                                
            />}
        />
    </div>
})

const TextareaInput = React.memo((props) =>{

    const classes = useStyles()

    const handleChange = (e) => {         
        props.setValue(props.field, e.target.value)
    }

    // console.log(props.field+":render"); 
    
    return (
        <div className={classes.textareaInput} style={props.style?props.style:{}}>
            <Typography variant="subtitle1">{props.label}</Typography>
            <textarea 
                onChange={handleChange}
                value={props.value===null?"":props.value}     
                className={classes.textarea}          
            />
        </div>
    )
})

const SelectInput = React.memo((props) =>{

    const classes = useStyles()

    const handleChange = (e) =>{
        props.setValue(props.field, e.target.value)
    }

    const options = JSON.parse(props.options)

    const getSelected = (val)=>{
        let f_arr = _.filter(options, (o)=>{return o.value === val})
        if(f_arr.length>0){
            return f_arr[0].label
        }else{
            return val
        }
    }

    // console.log(props.field+":render"); 

    return <div className={classes.selectInput}>
        <FormControl className={classes.formControl} variant={props.variant?props.variant:"outlined"} disabled={props.disabled?true:false}>
            <InputLabel id={props.field}>{props.label}</InputLabel>
            <Select
            labelId={props.field}
            id={props.field}
            value={props.value===null?"":props.value}
            onChange={handleChange}
            label={props.label}
            // displayEmpty
            renderValue={(value)=><span>{getSelected(value)}</span>}
            >
                {_.map(options, (item, key)=>{
                    return <MenuItem key={item.value} disabled={item.disabled?true:false} value={item.value} className={classes.selectItem}>{item.label}</MenuItem>
                })}       
            </Select>
        </FormControl>
    </div>
})


const MutiSelectInput = React.memo((props) =>{
    const classes = useStyles()

    const handleChange = (e) =>{
        let newSelectValue = _.orderBy(e.target.value, [function(o){return parseInt(o)}], ['asc'])
        props.setValue(props.field, newSelectValue.join())
    }

    const options = JSON.parse(props.options)

    const getSelected = (val)=>{
        let f_arr = _.filter(options, (o)=>{return o.value === val})
        if(f_arr.length>0){
            return f_arr[0].label
        }else{
            return val
        }
    }

    // console.log(props.field+":render"); 
    const valueArr = props.value?props.value.split(','):[]

    return <div className={classes.selectInput}>
        <FormControl className={classes.formControl} variant="outlined">
            <InputLabel id={props.field}>{props.label}</InputLabel>
            <Select
            labelId={props.field}
            id={props.field}
            multiple
            value={valueArr}
            onChange={handleChange}
            label={props.label}    
            input={<Input id={props.field+"-select_input"} />}       
            renderValue={(selected) => (
                <div className={classes.chips}>
                  {selected.map((value) => (
                    <Chip color="secondary" key={value} label={getSelected(value)} className={classes.chip} />
                  ))}
                </div>
            )}
            >
                {_.map(options, (item, key)=>{
                    return <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                })}       
            </Select>
        </FormControl>
    </div>
})


const boolean_obj = {
    "Y":true,
    "N":false
}

const CheckBoxInput = React.memo((props) =>{

    const classes = useStyles()

    const handleCheckChange = (e) => {      
        props.setValue(props.field, e.target.checked === true?"Y":"N")        
    }   

    // console.log(props.field+":render");     

    return <div className={classes.checkboxInput}>
        <FormControlLabel
            control={<Checkbox 
                checked={boolean_obj[props.value]} 
                color="primary" 
                onChange={handleCheckChange} 
                name={props.label} 
            />}
            label={props.label} 
        />
    </div>
   
})

CheckBoxInput.propTypes ={
    value:PropTypes.oneOf(['Y', 'N']).isRequired,
}


const CheckBoxGroupInput = React.memo((props) =>{

    const classes = useStyles()

    const valueArr = props.value?props.value.split(','):[]   

    const handleCheckChange = (col)=> (e)=>{

        let newValueArr = _.cloneDeep(valueArr)
        
        if(e.target.checked){
            newValueArr.push(col)
        }else{
            newValueArr = _.filter(valueArr, (o)=>{return o !== col})
        }
        props.setValue(props.field, newValueArr.join())
    }
    
    const options = JSON.parse(props.options)
  
    return <div className={classes.checkBoxGroupInput}>
        <Typography style={{ width:"100%", marginBottom:"10px"}}>{props.label}</Typography>
        {_.map(options, (item, key)=>{
            return <FormControlLabel key={item.label}
            control={<Checkbox               
                checked={valueArr.indexOf(item.value)>-1} 
                color="primary" 
                onChange={handleCheckChange(item.value)} 
                name={item.label} 
            />}
            label={item.label} 
        />
        })}
        
    </div>
})

const RadioInput = React.memo((props) =>{

    const classes = useStyles()

    const handleChange = (e) => {      
        props.setValue(props.field, e.target.value)        
    }   

    // console.log(props.field+":render"); 

    return  <RadioGroup aria-label={props.label} name={props.label} value={props.value} onChange={handleChange} className={classes.radioGroup}>
            {_.map(props.options, (item, key)=>{
                return <React.Fragment key={key}>
                <FormControlLabel  value={item.value} control={<Radio color="primary"/>} label={<Typography style={{fontWeight:"700"}}><pre>{`${item.label}${item.msg?`　(*${item.msg})`:''}`}</pre></Typography>} />
                {/* <p style={{paddingLeft:"15px", color:"#f03a2e", marginTop:"2px"}}>{item.description}</p>                 */}
                </React.Fragment>
            })}                             
    </RadioGroup>
    
   
})

const DateInput =React.memo((props) =>{
    const classes = useStyles()

    const handleChange = (date) => {  
        if(isValid(date)){
            props.setValue(props.field, format(date, "yyyyMMdd"))
        }else{
            props.setValue(props.field, date)
        }         
        
        // props.setValue(props.field, date?(date==="Invalid Date"?"Invalid Date":format(date, "yyyyMMdd")):null)
    }   
    
    const {value} = props

    // console.log(props.field+":render");

    return <div className={classes.textInput}>
        <KeyboardDatePicker
            value={typeof value === 'string'? parse(value,'yyyyMMdd', new Date(7000, 0, 1)): value}
            // value={value?(value==="Invalid Date"?"Invalid Date":parse(value,'yyyyMMdd', new Date(7000, 0, 1))):null} 
            // value={'Invalid Date'}
            fullWidth
            label={props.label}
            autoOk
            onChange={handleChange} 
            format="yyyy/MM/dd"
            clearable
            inputVariant={props.variant?props.variant:"standard"}
            disabled={props.disabled?props.disabled:false} 
            openTo="year"
            // error                      
        />
    </div>   
})



export { 
    TextInput, 
    TextareaInput, 
    SelectInput, 
    MutiSelectInput,
    CheckBoxInput, 
    CheckBoxGroupInput,
    RadioInput, 
    AutoCompleteInput,
    DateInput 
}
